import { render, staticRenderFns } from "./BottomForm.vue?vue&type=template&id=77043184&scoped=true&"
import script from "./BottomForm.vue?vue&type=script&lang=js&"
export * from "./BottomForm.vue?vue&type=script&lang=js&"
import style0 from "./BottomForm.vue?vue&type=style&index=0&id=77043184&lang=less&scoped=true&"
import style1 from "./BottomForm.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77043184",
  null
  
)

export default component.exports